import { PartialType, ApiPropertyOptional } from '@nestjs/swagger'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Type } from '@nestjs/common'
import { IsUUID, IsOptional } from 'class-validator'
import { CreateProgramCompetencyDto } from './create-program-competency.dto'

export class UpdateProgramCompetencyDto extends PartialType(
  CreateProgramCompetencyDto
) {
  @ApiPropertyOptional({ description: 'Program version UUID' })
  @IsUUID()
  @IsOptional()
  override programVersionId?: string

  @ApiPropertyOptional({ description: 'Competency UUID' })
  @IsUUID()
  @IsOptional()
  override competencyId?: string
}
